import { render, staticRenderFns } from "./weekHeader.vue?vue&type=template&id=0d28e2c4"
import script from "./weekHeader.vue?vue&type=script&lang=js"
export * from "./weekHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports